import { api, fetchRespJson, postData } from "apis/base";

export default {
  getCrossCheckSheets,
  createCrossCheckSheet,
  refreshCrossCheckSheet,
  shareCrossCheckSheet,
  deleteCrossCheckSheet,
  createCcsInstance,
  refreshCcsInstance,
  shareCcsInstance,
  deleteCcsInstance,
  getOperationStatus,
};

async function getOperationStatus({ operationId }) {
  let apiUrl = `${api}/operation-status/${operationId}`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

async function getCrossCheckSheets({ networkId }) {
  let apiUrl = `${api}/network/${networkId}/cross-check-sheets`;
  const r = await fetchRespJson(apiUrl);
  return r;
}

// params: { networkId, name }
async function createCrossCheckSheet(params) {
  let apiUrl = `${api}/network/${params.networkId}/create-cross-check-sheet`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, startDate, endDate }
async function refreshCrossCheckSheet(params) {
  let apiUrl = `${api}/network/${params.networkId}/refresh-cross-check-sheet`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, emails }
async function shareCrossCheckSheet(params) {
  let apiUrl = `${api}/network/${params.networkId}/share-cross-check-sheet`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId }
async function deleteCrossCheckSheet(params) {
  let apiUrl = `${api}/network/${params.networkId}/delete-cross-check-sheet`;
  delete params.networkId;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, name }
async function createCcsInstance(params) {
  let apiUrl = `${api}/network/${params.networkId}/cross-check-sheet/${params.sheetId}/create-instance`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, instanceId, startDate, endDate }
async function refreshCcsInstance(params) {
  let apiUrl = `${api}/network/${params.networkId}/cross-check-sheet/${params.sheetId}/refresh-instance`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, instanceId, emails }
async function shareCcsInstance(params) {
  let apiUrl = `${api}/network/${params.networkId}/cross-check-sheet/${params.sheetId}/share-instance`;
  return await postData(apiUrl, params);
}

// params: { networkId, sheetId, instanceId }
async function deleteCcsInstance(params) {
  let apiUrl = `${api}/network/${params.networkId}/cross-check-sheet/${params.sheetId}/delete-instance`;
  return await postData(apiUrl, params);
}
